import { Descope } from '@descope/react-sdk';
import React from 'react';

import { useCheckOrganizationExistense } from '@portals/api/organizations';

import { Authorized } from '../Authorized';
import { useSignUpWizard } from '../wizard/wizard.hooks';
import { StepIdEnum } from '../wizard/wizard.types';

export function Authentication() {
  const { contextData, skipToStep } = useSignUpWizard();

  const checkOrganizationExistence = useCheckOrganizationExistense();

  const onSubmit = async ({ email }: { email: string }) => {
    try {
      const orgExists = await checkOrganizationExistence.mutateAsync({
        email,
      });

      if (orgExists.in_use) {
        await skipToStep(StepIdEnum.OrganizationExists);
        return;
      }

      if (!orgExists.in_use) {
        await skipToStep(StepIdEnum.OrganizationDoesntExists);
        return;
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (contextData.auth) {
    return <Authorized />;
  }

  return (
    <Descope
      flowId="create-organization"
      onSuccess={async (e) => {
        await onSubmit({ email: e.detail.user.email });
      }}
    />
  );
}
